module.exports = __webpack_public_path__ + "static/img/mvshhh.c6125e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/mvshhh.png
// module id = 6GmW
// module chunks = 0